export const pt = {
    'buttons': {
        'return': 'Voltar'
    },
    'selects': {
        'currency': {
            'label': 'Moeda',
            'placeholder': 'Escolha uma moeda',
            'options-title': 'Lista de moedas disponíveis'
        },
        'currency-and-network': {
            'placeholder': 'Escolha uma moeda e uma rede',
            'options-title': 'Lista de moedas disponíveis'
        },
        'selected-label': 'Selecionado: {selected} de {length}',
        'search': 'Pesquisar',
        'errors': {
            'invalid': 'Valor inválido',
            'required': 'Obrigatório',
            'card-holder': 'Insira o nome e sobrenome do titular do cartão',
            'input-amount': 'Insira o valor',
            'fill-card': 'Preencha os dados do cartão'
        },
        'empty-list': 'Lista vazia',
        'address': {
            'label': 'Endereço de saque em {currency}',
            'options-title': 'Lista de endereços disponíveis'
        },
        'cardholder-input': {
            'placeholder': 'Titular do cartão'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Seu endereço para depósito'
            },
            'invoice': {
                'address': 'Endereço',
                'paid-amount': 'Valor pago'
            }
        }
    },
    'labels': {
        'deposit': 'Depósito',
        'withdraw': 'Saque',
        'currency': 'Moeda',
        'amount': 'Valor',
        'invoice': {
            'remaining-time': 'Tempo restante para pagar',
            'status': {
                'expires': 'Tempo esgotado',
                'success': 'Pagamento bem-sucedido',
                'error': 'Erro'
            },
            'partially-paid': {
                'title': 'Parcialmente pago',
                'info': 'O valor foi parcialmente pago. O valor restante deve ser pago para que o pagamento seja bem-sucedido.'
            },
            'orphan': {
                'title': 'Transação órfã',
                'description': 'Uma das transações neste pedido contém uma rede ou moeda incorreta.',
                'contact': 'Entre em contato com o suporte técnico com o ID:'
            },
            'you-paid': 'Você pagou',
            'active-order': 'Pedido ativo',
            'new-invoice': 'Nova fatura',
            'order-id': 'ID da fatura',
            'payment-amount': 'Valor do pagamento'
        },
        'continue': 'Continuar',
        'payout': {
            'address': 'Endereço de saque em {currency}',
            'tag-or-memo': 'TAG ou MEMO',
            'status': {
                'processed': 'Bem-sucedido',
                'error': 'Erro',
                'orphan': 'Transação órfã',
                'approve_rejected': 'Rejeitado',
                'in-progress': 'Em andamento',
                'need-approve': 'Requer aprovação',
                'awaiting-confirmation': 'Sua solicitação de saque está aguardando confirmação'
            },
            'info': {
                'withdraw-id': 'ID do saque',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Moeda e rede',
                'address': 'Endereço',
                'tag-or-memo': 'TAG ou MEMO',
                'amount': 'Valor do saque'
            }
        },
        'fiat': {
            'title': 'Depósito via fiat',
            'info': {
                'amount': 'Valor',
                'date': 'Data do pagamento',
                'id': 'ID do depósito',
                'system': 'Sistema de pagamento'
            },
            'status': {
                'new': 'Novo',
                'pending': 'Pendente',
                'authorized': 'Autorizado',
                'confirmed': 'Confirmado',
                'reconciled': 'Conciliado',
                'error': 'Erro',
                'declined': 'Recusado'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'ID do widget incorreto',
        'wrong-ext-user-id': 'ID de usuário externo incorreto',
        '404': 'Ops! Procuramos, mas não encontramos o que você está procurando.',
        'without-xt-user-id-withdrawal': 'Saque indisponível. O parâmetro extUserId não foi passado',
        'without-xt-user-id-deposit': 'Depósito indisponível. O parâmetro extUserId não foi passado'
    },
    'invoice': {
        'order': 'Pedido',
        'inputs': {
            'email': {
                'label': 'Endereço de e-mail',
                'placeholder': 'Insira seu endereço de e-mail'
            },
            'amount': {
                'label': 'Valor',
                'placeholder': 'Insira o valor'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Valor em',
                'rate': 'Taxa de câmbio',
                'payment-id': 'ID do pagamento',
                'description': 'Descrição'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Não atualize a página ou abra a fatura em uma',
            'new-tab': 'nova aba'
        },
        'statuses': {
            'ERROR': 'ERRO',
            'PENDING': 'PENDENTE',
            'PROCESSED': 'PROCESSADO',
            'REJECTED': 'REJEITADO',
            'OVERPAID': 'PAGO A MAIS',
            'CREATED': 'CRIADO',
            'PARTIAL': 'PAGO PARCIALMENTE',
            'INIT': 'INICIADO',
            'EXPIRED': 'EXPIRADO'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Depósito',
            'payment-history': 'Histórico de pagamentos'
        },
        'payment-history': {
            'empty-label': 'Todas as suas transações enviadas para o endereço indicado estarão disponíveis aqui',
            'headers': {
                'date': 'Data e hora',
                'amount': 'Valor',
                'tx': 'Tx-Hash',
                'status': 'Status'
            },
            'statuses': {
                'processed': 'Processado',
                'pending': 'Pendente',
                'rejected': 'Rejeitado',
                'error': 'Erro'
            },
            'in': 'em'
        },
        'qr-block': {
            'empty-label': 'Recarregar com criptomoeda',
            'qr-info-pre-invoice': 'Envie apenas',
            'qr-info-pre-personal': 'Envie qualquer quantia apenas para',
            'qr-info-post': 'para este endereço',
            'qr-info-minimal': 'Transferências inferiores a 1 USD não são creditadas'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Depósito via fiat',
            'payment-history': 'Histórico de pagamentos'
        },
        'labels': {
            'pay': 'Pagar',
            'service-commission': 'Valor da comissão de serviço',
            'total': 'Total',
            'you-pay': 'Você paga'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Transação órfã',
            'info': 'Uma das transações neste pedido contém uma rede ou moeda incorreta.',
            'support': 'Entre em contato com o suporte técnico com o ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'Ao clicar no botão "Continuar", você automaticamente concorda com',
        'our': 'nossa política de cookies'
    },
    'payout': {
        'payout': 'Pagamento',
        'output': 'Saque',
        'withdraw': 'Retirada',
        'errors': {
            'wrong-address': 'O endereço não pertence à rede {network}'
        }
    }
}
